import React, { useRef, useState } from 'react';
import { Icon } from '@monorepo/icons';
import { Button, BUTTON_INTENT, Modal } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';
import { useNavigate } from 'react-router-dom';
import useUser from '../../hooks/useUser';
import useDeleteContactPersonFO from '../../hooks/useDeleteContactPersonFO';
import styles from './index.module.css';

const UserContactsListFO = () => {
  const { data: user, isLoading: isUserLoading } = useUser();
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = location;
  const { mutate } = useDeleteContactPersonFO();
  const shutterRef = useRef(null);
  const [userInfo, setItemUser] = useState(null);

  const handleOpen = (item: any) => {
    setItemUser(item);
    if (shutterRef?.current) {
      shutterRef.current.setIsShow(true);
    }
  };

  const handleClose = () => {
    if (shutterRef?.current) {
      shutterRef?.current.setIsShow(false);
    }
  };

  const handleDelete = () => {
    // @ts-ignore
    mutate(userInfo);
    handleClose();
  };

  // Still loading user → show loader (optional)
  if (isUserLoading) {
    return <div>Loading...</div>;
  }

  // If user has limited access → block the page
  if (user?.isLimited) {
    return (
      <div className={styles.emptyList}>
        {t('uitext.no_permission_to_view_page')}
      </div>
    );
  }

  // Regular content if user has permission
  if (user) {
    return (
      <>
        {user.contactPersonsList.length === 0 && (
          <div className={styles.emptyList}>{t('contactsList.empty')}</div>
        )}
        <table className={styles.container}>
          <tbody>
            {user.contactPersonsList.map((item: any) => (
              <tr
                className={styles.listItem}
                key={`${item.name}-${item.phone}`}
              >
                <td className={styles.item}>
                  <div>{item.name}</div>
                  <div>{item.position}</div>
                </td>
                <td className={styles.item}>
                  <div>{item.phone}</div>
                  <div>{item.email}</div>
                </td>
                <td>
                  <Icon
                    name="trash"
                    className={styles.icon}
                    onClick={() => handleOpen(item)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Button
          intent={BUTTON_INTENT.tertiary}
          isOnlyIcon
          onClick={() => navigate(`${pathname}/add`)}
          className={styles.addButton}
        >
          <Icon name="plus_round" className={styles.iconPlus} />
          {t('personalInfo.form.add')}
        </Button>
        <Modal ref={shutterRef}>
          <div className={styles.modal}>
            <div>
              {t('delete.confirmation.title')}
              {` ${userInfo?.name}?`}
            </div>
            <div className={styles.buttonWrapper}>
              <Button
                className={styles.buttonReset}
                intent={BUTTON_INTENT.tertiary}
                onClick={() => handleClose()}
              >
                {t('personalInfo.form.cancel')}
              </Button>
              <Button
                intent={BUTTON_INTENT.primary}
                onClick={() => handleDelete()}
              >
                {t('personalInfo.form.confirm')}
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }

  // Fallback (if no user)
  return null;
};

export default UserContactsListFO;
